

























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Order } from '@/api/model/order'

@Component
export default class ColumnLastUpdate extends Vue {
    @Prop({ required: true }) order!: Order
    @Prop({ type: String, default: '#00A389' }) readonly color!: string

    routeToOneContactDetail(order: Order) {
        return {
            name: 'one_contact_detail',
            params: {
                contactId: order.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    routeToOrdersDetail(order: Order) {
        return {
            name: 'orders_detail',
            params: {
                orderId: this.order.id,
                contactId: this.order.referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }
}
